export default "__VITE_ASSET__BknU6ohu__"